import * as Yup from "yup";

export const EMAIL_SCHEMA = Yup.string()
  .required("Email is required")
  .email("Invalid email format");

export const getPhoneNumberSchema = (isRequired: boolean) => {
  const phoneSchema = Yup.string()
    .transform((value, originalValue: string | null) => {
      return originalValue ? originalValue.replace(/\D/g, "") : originalValue;
    })
    .matches(/^\d{10}$/, "Invalid phone number format. Must be 10 digits.");

  return isRequired
    ? phoneSchema.required("Phone Number is required")
    : phoneSchema;
};

export const PASSWORD_SCHEMA = Yup.string().required("Password is required");

export const getNewPasswordSchema = (noMatches?: boolean) => {
  const passwordSchema = Yup.string()
    .min(8, "Password must be at least 8 characters long")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9!@#%&])(?=.{6,})/,
      "New password must contain at least 1 uppercase letter, 1 lowercase letter, and 1 number or special character",
    )
    .test(
      "White space at start or end of password",
      "Password cannot start or end with whitespace",
      (value) => {
        return value?.trim() == value;
      },
    )
    .required("New password is required");

  return noMatches
    ? passwordSchema.notOneOf(
        [Yup.ref("password")],
        "Passwords must be different",
      )
    : passwordSchema;
};

export const firstNameSchema = Yup.string().required("First Name is required");
export const lastNameSchema = Yup.string().required("Last Name is required");

export const OBJECT_ID_REGEX = "[a-zA-Z0-9]{24}";

export const getMongoIdSchema = (name: string) => {
  return Yup.string().test(
    "is-12-byte-or-24-hex",
    `Invalid ${name}`,
    (value) => {
      if (!value) return true;
      return new RegExp(`^${OBJECT_ID_REGEX}$`).test(value);
    },
  );
};
